import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import moment from "moment";
import Select from "react-select";
import PubSub from "pubsub-js";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import CityState from "../../constants/CityState.json";
import * as constants from "../../constants/CONSTANT";

const SupplierEdit = (props) => {
  let fnYear;
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});
  const [supplierOption, setOptionSupplier] = useState({});
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [itemOption, setOptionItem] = useState({});
  const [selectedItem, setSelectedItem] = useState({});
  const [branchOption, setOptionBranch] = useState({});
  const [selectedbranch, setSelectedBranch] = useState({});
  const [clientOption, setOptionClient] = useState({});
  const [selectedClient, setSelectedClient] = useState({});
  const [vechicleOption, setOptionVechicle] = useState({});
  const [selectedVechicle, setSelectedVechicle] = useState({});
  const [selectedCity, setSelectedCity] = useState({});
  const [cityOption, setOptionCity] = useState({});
  const [selectedToCity, setSelectedToCity] = useState({});
  const [challanData, setChallanData] = useState(
    location.state
      ? location.state
      : { challan_date: moment().format("YYYY-MM-DD") }
  );
  const [challanDieselData, setChallanDieselData] = useState(
    location.state
      ? location.state
      : { challan_advance_date: moment().format("YYYY-MM-DD") }
  );
  const [challanAdvanceData, setChallanAdvanceData] = useState(
    location.state
      ? location.state
      : { challan_date: moment().format("YYYY-MM-DD") }
  );
  const [selectedContacts, setSelectedContact] = useState({});
  const [optionContacts, setOptionsContacts] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const fnYear = await trasportApi.fetchAllActiveFinancialYears();
      const itemRec = await trasportApi.fetchAllItem();
      const branchRec = await trasportApi.fetchAllBranch();
      const clientRec = await trasportApi.fetchAllClient();
      const vechicleRec = await trasportApi.fetchAllVehicles();
      const cityRec = await trasportApi.fetchAllCity();
      const supplierRec = await trasportApi.fetchAllSupplier();
      const contactsRec = await trasportApi.fetchContacts();

      if (fnYear && fnYear.length) {
        let ar = [];
        fnYear.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });

        const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
        const currentYear = new Date().getFullYear();
        let defaultOption;

        if (currentMonth >= 3) {
          // March is the 3rd month
          defaultOption = ar.find(
            (option) => option.label === `${currentYear}-${currentYear + 1}`
          );
        } else {
          defaultOption = ar.find(
            (option) => option.label === `${currentYear - 1}-${currentYear}`
          );
        }

        if (defaultOption) {
          setSelectedFinancialYear(defaultOption);
          setChallanData({
            ...challanData,
            financial_year_id: defaultOption.value,
          });
        } else if (location?.state) {
          const acc = ar.find(
            (acc) => acc.value === location.state.financial_year_id
          );
          setSelectedFinancialYear(acc);
        }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }
      //Item Api Data
      if (itemRec && itemRec.length) {
        let ar = [];
        itemRec.forEach((item) => {
          ar.push({
            value: item.id,
            label: item.name,
            price_deduction: item.price_deduction,
          });
        });

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.item_id);
          setSelectedItem(acc);
        }
        setOptionItem(ar);
      } else {
        setOptionItem([]);
      }

      //Contact Api Data
      if (contactsRec && contactsRec.length) {
        let ar = [];
        contactsRec.forEach((item) => {
          ar.push({
            value: item.id,
            label: `${item.firstname} ${item.lastname}`,
          });
        });

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.agent_id);
          setSelectedContact(acc);
        }
        setOptionsContacts(ar);
      } else {
        setOptionsContacts([]);
      }
      //Branch Api Data.
      if (branchRec && branchRec.length) {
        let ar = [];
        branchRec.forEach((item) => {
          ar.push({ value: item.id, label: item.branch_name });
        });

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.branch_id);
          setSelectedBranch(acc);
          // setSelectedAdvanceBranch(acc2);
        }
        setOptionBranch(ar);
        // setOptionAdvanceBranch(ar);
      } else {
        setOptionBranch([]);
      }
      //Client Api Data.
      if (clientRec && clientRec.length) {
        let ar = [];
        clientRec.forEach((item) => {
          ar.push({ value: item.id, label: item.client_name });
        });

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.client_id);
          setSelectedClient(acc);
        }
        setOptionClient(ar);
      } else {
        setOptionClient([]);
      }

      // //Vechile Api Data.
      // if (vechicleRec && vechicleRec.length) {
      //   let ar = [];
      //   vechicleRec.forEach((item) => {
      //     ar.push({ value: item.id, label: item.vehicle_number });
      //   });

      //   if (location?.state) {
      //     const acc = ar.find((acc) => acc.value === location.state.vehicle_id);
      //     setSelectedVechicle(acc);
      //   }
      //   setOptionVechicle(ar);
      // } else {
      //   setOptionVechicle([]);
      // }

      // Vehicle API Data.
      if (vechicleRec && vechicleRec.length) {
        let uniqueVehicles = new Map();

        vechicleRec.forEach((item) => {
          if (!uniqueVehicles.has(item.vehicle_number)) {
            uniqueVehicles.set(item.vehicle_number, {
              value: item.id,
              label: item.vehicle_number,
            });
          }
        });

        let ar = Array.from(uniqueVehicles.values());

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.vehicle_id);
          setSelectedVechicle(acc);
        }

        setOptionVechicle(ar);
      } else {
        setOptionVechicle([]);
      }

      //City From and To City Api Data.
      if (cityRec && cityRec.length) {
        let ar = [];
        cityRec.forEach((item) => {
          ar.push({ value: item.id, label: item.city_name });
        });

        if (location?.state) {
          const acc = ar.find(
            (acc) => acc.value === location.state.from_station_id
          );
          const acc2 = ar.find(
            (acc) => acc.value === location.state.to_station_id
          );
          setSelectedCity(acc);
          setSelectedToCity(acc2);
        }
        setOptionCity(ar);
      } else {
        setOptionCity([]);
      }

      //Supplier Api Data
      if (supplierRec && supplierRec.length) {
        let ar = [];
        supplierRec.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });

        if (location?.state) {
          const acc = ar.find(
            (acc) => acc.value === location.state.supplier_id
          );
          setSelectedSupplier(acc);
        }
        setOptionSupplier(ar);
      } else {
        setOptionSupplier([]);
      }
    };
    //By Default Value to Show As per Client Requiment.
    challanData.commission_fixed = 500;

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedChallanData = { ...challanData, [name]: value };

    // Validate future date for "challan_date"
    if (name === "challan_date") {
      const selectedDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset today's time for comparison

      if (selectedDate > today) {
        alert("Future Challan Date are not allowed."); // Display validation error
        setValidated(true);
        // PubSub.publish('RECORD_ERROR_TOAST', { title: 'Future Challan Date are not allowed', message: "Future Challan Date are not allowed" });
        // return; // Stop further execution if validation fails
      }
    }

    // Recalculate total_freight if dispatch_weight or rate changes
    if (name === "dispatch_weight" || name === "rate") {
      const dispatchWeight =
        name === "dispatch_weight"
          ? parseFloat(value)
          : parseFloat(updatedChallanData.dispatch_weight);
      const rate = name === "rate" ? value : updatedChallanData.rate;
      updatedChallanData.total_freight = (dispatchWeight * rate).toFixed(2);
    }
    if (name === "dispatch_weight" || name === "actual_item_rate") {
      const dispatchWeight =
        name === "dispatch_weight" ? value : updatedChallanData.dispatch_weight;
      const actualRate =
        name === "actual_item_rate"
          ? value
          : updatedChallanData.actual_item_rate;
      updatedChallanData.actual_total_freight = (
        dispatchWeight * actualRate
      ).toFixed(2);
      updatedChallanData.client_balance =
        updatedChallanData.actual_total_freight;
    }

    if (name === "dispatch_weight" || name === "client_commission_rate") {
      const dispatchWeight =
        name === "dispatch_weight" ? value : updatedChallanData.dispatch_weight;
      const actualRate =
        name === "client_commission_rate"
          ? value
          : updatedChallanData.client_commission_rate;
      updatedChallanData.client_commission_amount = (
        dispatchWeight * actualRate
      ).toFixed(2);
    }

    if (name === "dispatch_weight" || name === "commission_rate_per_ton") {
      const dispatchWeight =
        name === "dispatch_weight" ? value : updatedChallanData.dispatch_weight;
      const actualRate =
        name === "commission_rate_per_ton"
          ? value
          : updatedChallanData.commission_rate_per_ton;
      updatedChallanData.commission = (dispatchWeight * actualRate).toFixed(2);
    }
    console.log("challanData", challanData);
    setChallanData(updatedChallanData);
  };

  const handleAdvanceChallanChange = (e) => {};

  const handleAdvanceChallanDesialChange = (e) => {};

  const checkRequiredFields = () => {
    if (
      challanData.branch_id &&
      challanData.client_id &&
      challanData.challan_date &&
      challanData.vehicle_id &&
      challanData.challan_no &&
      challanData.g_r_no &&
      challanData.agent_id &&
      challanData.financial_year_id &&
      challanData.item_id &&
      challanData.from_station_id &&
      challanData.to_station_id &&
      challanData.dispatch_weight &&
      challanData.rate &&
      challanData.actual_item_rate &&
      challanData.client_commission_rate &&
      challanData.commission_rate_per_ton
    ) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    // Check for duplicate challan or GR numbers
    // const data = {
    //   challan_no: challanData.challan_no,
    //   financial_year_id: challanData.financial_year_id,
    //   branch_id : challanData.branch_id,
    // };
    // const data2 = {
    //   gr_no: challanData.g_r_no,
    //   financial_year_id: challanData.financial_year_id,
    //   branch_id : challanData.branch_id,
    // };

    // // Check challan number
    //   const checkChallanNumber = await trasportApi.fetchChallanDetailsByChallanNo(data);
    //   if (checkChallanNumber?.success === true) {
    //     PubSub.publish("RECORD_ERROR_TOAST", {
    //       title: "Challan Number Already Exists",
    //       message: "Challan Number Already Exists",
    //     });
    //     return;
    //   }

    //   // Check GR number
    //   const checkGrNumber = await trasportApi.fetchChallanDetailsByGRNo(data2);
    //   // console.log("checkgr",checkGrNumber.data);
    //   if (checkGrNumber?.success === true) {
    //     PubSub.publish("RECORD_ERROR_TOAST", {
    //       title: "GR Number Already Exists",
    //       message: "GR Number Already Exists",
    //     });
    //     return;
    //   }

    let result2 = {};

    if (challanData.id) {
      result2 = await trasportApi.saveChallan(challanData);
      if (result2.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record Updated successfully",
        });
        navigate(`/challans/${challanData.id}`, { state: challanData });
      }
    } else {
      // console.log("Create Time Item =>",challanData)
      result2 = await trasportApi.createChallan(challanData);
      if (result2.errors) {
        // PubSub.publish("RECORD_ERROR_TOAST", {
        //   title: "Record ERROR",
        //   message: result2.errors[0].msg,
        // });
        // console.log(result2.errors)
        alert(result2.errors);
        // if(result2.errors && result2.errors.length > 0){
        //   const errorMessage = result2.errors[0].msg;
        //   console.log(errorMessage);
        //   alert(errorMessage);
        // }
      } else {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        navigate(`/challans/${result2.id}`, { state: result2 });
      }
    }
  };

  const handleCancel = () => {
    if (location.state?.id) {
      navigate("/challans/" + challanData.id, { state: challanData });
    } else {
      navigate("/challans/");
    }
  };

  //FinancialYear
  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setChallanData({ ...challanData, financial_year_id: e.value });
  };

  //Item
  const handleItem = (e) => {
    setSelectedItem(e);
    challanData.item_deduction_rate = itemOption[0].price_deduction;

    setChallanData({ ...challanData, item_id: e.value });
  };

  //Client
  const handleClient = (e) => {
    setSelectedClient(e);
    setChallanData({ ...challanData, client_id: e.value });
  };

  //Branch
  const handleBranch = (e) => {
    setSelectedBranch(e);
    setChallanData({ ...challanData, branch_id: e.value });
  };

  //Vehicle
  const handleVehicle = (e) => {
    setSelectedVechicle(e);
    setChallanData({ ...challanData, vehicle_id: e.value });
  };

  //From City
  const handleCity = (e) => {
    setSelectedCity(e);
    setChallanData({ ...challanData, from_station_id: e.label });
  };

  //To City
  const handleToCity = (e) => {
    setSelectedToCity(e);
    setChallanData({ ...challanData, to_station_id: e.label });
  };

  //Advance Diesel Supplier.
  const handleSupplier = (e) => {
    setSelectedSupplier(e);
    setChallanDieselData({ ...challanDieselData, supplier_id: e.value });
  };

  //Challan Contact (Agent).
  const handleContact = (e) => {
    setSelectedContact(e);
    setChallanData({ ...challanData, agent_id: e.value });
  };

  const handlerAddRow = (e) => {};

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ChallanEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Edit Challan Master</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Challan Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="challan_date"
                      placeholder="Enter Your Challan Date"
                      required
                      value={
                        challanData
                          ? moment(challanData.challan_date).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Client / Party Name
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Party Name"
                      value={selectedClient}
                      onChange={handleClient}
                      options={clientOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Client Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Branch Name
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Branch Name"
                      value={selectedbranch}
                      onChange={handleBranch}
                      options={branchOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Branch Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Challan Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="challan_no"
                      placeholder="Enter Challan Number"
                      value={challanData.challan_no}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Vehicle</Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Vehicle Name"
                      value={selectedVechicle}
                      onChange={handleVehicle}
                      options={vechicleOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Vehicle Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      GR Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="g_r_no"
                      placeholder="Enter Your GR Number"
                      value={challanData.g_r_no}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      DO Number
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="d_o_no"
                      placeholder="Enter Your d_o_no"
                      value={challanData.d_o_no}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Select Agent Name (Contacts)
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Item Name"
                      value={selectedContacts}
                      onChange={handleContact}
                      options={optionContacts}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Contact Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Item</Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Item Name"
                      value={selectedItem}
                      onChange={handleItem}
                      options={itemOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Item Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Item Deduction Rate
                    </Form.Label>
                    <Form.Control
                      // required
                      type="number"
                      name="item_deduction_rate"
                      placeholder="Enter Your Item Deduction Rate"
                      value={challanData.item_deduction_rate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      From Station
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select From Station"
                      value={selectedCity}
                      onChange={handleCity}
                      options={cityOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select From Station.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      To Station
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select From Station"
                      value={selectedToCity}
                      onChange={handleToCity}
                      options={cityOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select To Station.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Cement Bags
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="cement_bags"
                      placeholder="Enter Your Cement Bagg"
                      value={challanData.cement_bags}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Dispatch Weight (in Ton)
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="dispatch_weight"
                      placeholder="Enter Dispatch Weight"
                      value={challanData.dispatch_weight}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Rate
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="rate"
                      placeholder="Enter Rate (Price ₹)"
                      value={challanData.rate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Total Freight
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="total_freight"
                      placeholder="Enter Total Freight"
                      value={challanData.total_freight}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Actual Item Rate
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="actual_item_rate"
                      placeholder="Enter Actual Item Rate"
                      value={challanData.actual_item_rate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Actual Total Freight
                    </Form.Label>
                    <Form.Control
                      // required
                      disabled
                      type="number"
                      name="actual_total_freight"
                      placeholder="Enter Actual Total Freight"
                      value={challanData.actual_total_freight}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Client Balance
                    </Form.Label>
                    <Form.Control
                      // required
                      disabled
                      type="number"
                      name="client_balance"
                      placeholder="Enter Client Balance"
                      value={challanData.client_balance}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Client Commission Rate
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="client_commission_rate"
                      placeholder="Enter Client Commission Rate"
                      value={challanData.client_commission_rate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Client Commission Amount
                    </Form.Label>
                    <Form.Control
                      required
                      disabled
                      type="number"
                      name="client_commission_amount"
                      placeholder="Enter Client Commission Amount"
                      value={challanData.client_commission_amount}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Commission Rate Per Ton
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="commission_rate_per_ton"
                      placeholder="Enter a Commission Rate Per Ton"
                      value={challanData.commission_rate_per_ton}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Commission Amount
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="commission"
                      placeholder="Enter a Commission Amount"
                      value={challanData.commission}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Commission Fixed Amount
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="commission_fixed"
                      placeholder="Enter a Commission Fixed Amount"
                      value={challanData.commission_fixed}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Labour
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="labour"
                      placeholder="Enter a Labour"
                      value={challanData.labour}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Constant Rate
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="constant_rate"
                      placeholder="Enter a Constant Rate"
                      value={challanData.constant_rate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Grade
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="grade"
                      placeholder="Enter a Grade"
                      value={challanData.grade}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row></Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};
export default SupplierEdit;
